(() => {
  'use strict';
  if (window.MBCKPriceRouter) return;
  const node = document.getElementById('MBCKPriceRouterConfig');
  if (!node) return;
  let cfg;
  try { cfg = JSON.parse(node.textContent); } catch (error) { console.error('MBCK Router config', error); return; }
  const tiers = (cfg.targets || []).filter(t => Number.isSafeInteger(t.cents) && /^https:\/\//.test(t.url)).sort((a,b) => a.cents-b.cents);
  const amount = cents => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
  let latest = null;
  let inCheckout = false;
  const route = (cents) => {
    const raw = Math.round(Number(cents) || 0);
    if (raw <= 0) return {kind:'EMPTY',raw,allowed:false,discount:0,surcharge:0};
    if (raw > cfg.maxOrderCents) return {kind:'OVER_MAX',raw,allowed:false,discount:0,surcharge:0};
    const matching = tiers.map(t => ({...t,diff:raw-t.cents}))
      .filter(t => t.diff >= 0 ? t.diff <= cfg.maxDiscountCents : -t.diff <= cfg.maxSurchargeCents)
      .sort((a,b) => Math.abs(a.diff)-Math.abs(b.diff) || b.diff-a.diff);
    const chosen = matching[0];
    if (!chosen) return {kind:'UNAVAILABLE',raw,allowed:false,discount:0,surcharge:0};
    return {kind:chosen.diff===0?'EXACT':chosen.diff>0?'DISCOUNT':'SURCHARGE',raw,
      target:chosen.cents,url:chosen.url,discount:Math.max(0,chosen.diff),surcharge:Math.max(0,-chosen.diff),allowed:true};
  };
  const calcFromCart = cart => {
    const items=Array.isArray(cart?.items)?cart.items:[];
    const totals=new Map();
    for(const item of items){
      const variant=String(item.variant_id || item.id);
      const next=(totals.get(variant)||0)+Number(item.quantity||0);
      totals.set(variant,next);
      if(next>5) return {kind:'QTY_LIMIT',raw:Number(cart.total_price||0),allowed:false,discount:0,surcharge:0};
    }
    return route(cart && Number.isFinite(Number(cart.total_price)) ? cart.total_price : 0);
  };
  const setText = (selector,text) => {document.querySelectorAll(selector).forEach(el => {if(el.textContent!==text)el.textContent=text;});};
  const show = (selector,yes) => {document.querySelectorAll(selector).forEach(el=>{el.hidden=!yes;});};
  const updateUI = (r) => {
    latest=r;
    const changed=r.discount>0||r.surcharge>0;
    const isAdd=r.surcharge>0;
    setText('[data-mbck-adjust-label]',isAdd?cfg.labels.surcharge:cfg.labels.discount);
    setText('[data-mbck-adjust-value]',(isAdd?'+':'−')+amount(isAdd?r.surcharge:r.discount));
    show('[data-mbck-adjust-row]',r.allowed&&changed);
    document.querySelectorAll('[data-mbck-adjust-row]').forEach(el=>el.classList.toggle('is-surcharge',isAdd));
    setText('[data-mbck-final-value]',amount(r.allowed?r.target:r.raw));
    show('[data-mbck-total-row]',r.raw>0);
    const message=r.kind==='OVER_MAX'?cfg.labels.maxOrder:r.kind==='QTY_LIMIT'?'Maximum 5 unités par article. Modifiez votre panier.':r.kind==='UNAVAILABLE'?cfg.labels.unavailable:'';
    setText('[data-mbck-status]',message);
    show('[data-mbck-status]',Boolean(message));
    document.querySelectorAll('[data-mbck-checkout]').forEach(el=>{
      const inactive=!r.allowed;
      el.setAttribute('aria-disabled',String(inactive));
      if ('disabled' in el) el.disabled=inactive;
      el.dataset.mbckUnavailable=String(inactive);
    });
    document.querySelectorAll('[data-mbck-native-total]').forEach(el=>{el.textContent=amount(r.allowed?r.target:r.raw);});
  };
  const ensureNativeUI=()=>{
    document.querySelectorAll('.cart-totals__container').forEach(total=>{
      if (total.parentElement?.querySelector('.mbck-native-breakdown')) return;
      const div=document.createElement('div');
      div.className='mbck-native-breakdown';
      div.innerHTML='<div class="mbck-native-line" data-mbck-adjust-row hidden><span data-mbck-adjust-label></span><strong data-mbck-adjust-value></strong></div><p class="mbck-native-status" data-mbck-status hidden></p>';
      total.before(div);
      const node=total.querySelector('.cart-totals__total-value bdi');
      if(node) node.setAttribute('data-mbck-native-total','');
    });
    document.querySelectorAll('.cart__checkout-button[name="checkout"]').forEach(el=>el.setAttribute('data-mbck-checkout',''));
  };
  const refresh=cart=>{ensureNativeUI();const r=calcFromCart(cart);updateUI(r);return r;};
  const fetchCart=async()=>{
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok) throw Error('Cart HTTP '+response.status);
    return response.json();
  };

  let isNavigating = false;
  const showTransition = () => {
    let overlay = document.getElementById('mbck-redirect-loading');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'mbck-redirect-loading';
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.innerHTML = '<div class="mbck-redirect-inner"><span class="mbck-redirect-spinner" aria-hidden="true"></span><strong>Paiement sécurisé</strong><span>Ouverture de votre page de paiement…</span></div>';
      document.body.appendChild(overlay);
    }
    overlay.hidden = false;
  };
  const hideTransition = () => {
    const overlay = document.getElementById('mbck-redirect-loading');
    if (overlay) overlay.hidden = true;
  };
  const checkout=async(knownCart)=>{
    if (inCheckout) return false;
    inCheckout=true;
    showTransition();
    let redirected = false;
    try {
      const cart = knownCart && Array.isArray(knownCart.items) && Number.isFinite(Number(knownCart.total_price))
        ? knownCart : await fetchCart();
      const r=refresh(cart);
      if (!r.allowed || !r.url) {
        setText('[data-mbck-status]',r.kind==='QTY_LIMIT'
          ? 'Maximum 5 unités par article.'
          : 'Ce montant ne permet pas le paiement. Modifiez votre panier.');
        show('[data-mbck-status]',true);
        return false;
      }
      const url=new URL(r.url);
      for (const key of ['sub2','sub3','sub4','sub5']) url.searchParams.delete(key);
      url.searchParams.set('sub1','MBCK');
      window.location.assign(url.toString());
      isNavigating=true;
      redirected=true;
      return true;
    } catch(error) {
      console.error('MBCK checkout routing',error);
      setText('[data-mbck-status]','Connexion au paiement impossible. Réessayez.');
      show('[data-mbck-status]',true);
      return false;
    } finally {
      if (!redirected) { inCheckout=false; isNavigating=false; hideTransition(); }
    }
  };
  window.addEventListener('pageshow',()=>{
    if (isNavigating) { inCheckout=false; isNavigating=false; hideTransition(); }
  });
  window.MBCKPriceRouter={config:cfg,route,refresh,checkout,fetchCart,amount};
  const shouldIntercept=el=>{
    if(!el) return false;
    if(el.matches?.('[data-mbck-checkout],button[name="checkout"],button[id="checkout"]')) return true;
    if(el.matches?.('a[href]')) {
      const value=el.getAttribute('href')||'';
      try { const url = new URL(value, location.origin); return url.origin === location.origin && (url.pathname === '/checkout' || url.pathname.startsWith('/checkout/')); } catch (e) { return false; }
    }
    return false;
  };
  document.addEventListener('click',event=>{
    const el=event.target.closest?.('[data-mbck-checkout],button[name="checkout"],button[id="checkout"],a[href]');
    if(!shouldIntercept(el)) return;
    event.preventDefault();event.stopImmediatePropagation();checkout();
  },true);
  document.addEventListener('submit',event=>{
    const f=event.target;
    const s=event.submitter;
    if((s&&shouldIntercept(s))||((f?.matches?.('form[action*="/cart"]')) && s?.name==='checkout')){
      event.preventDefault();event.stopImmediatePropagation();checkout();
    }
  },true);
  const bootstrap=()=>{ensureNativeUI();fetchCart().then(refresh).catch(error=>console.error('MBCK initial cart',error));};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bootstrap,{once:true});else bootstrap();
  document.addEventListener('cart:refresh',()=>fetchCart().then(refresh).catch(()=>{}));
  document.addEventListener('cart:updated',()=>fetchCart().then(refresh).catch(()=>{}));
})();
